var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"label",staticClass:"ruler-label",style:({
        top: `${_vm.top}px`,
        left: `${_vm.left}px`,
        display: `${_vm.visibility ? 'block' : 'none'}`
    })},[_vm._v(" "+_vm._s(_vm.value)+" м ")])
}
var staticRenderFns = []

export { render, staticRenderFns }